function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "lock");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/Lock",
  transform: "translate(-1.000000, 0.000000)",
  stroke: "#80A1FE",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "lock",
  transform: "translate(2.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 6.42857143,
  width: 12,
  height: 7.85714286,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.66666667,6.42857143 L2.66666667,3.57142857 C2.66666667,1.59898304 4.15905083,1.205385e-15 6,8.8817842e-16 C7.84094917,2.53765263e-16 9.33333333,1.59898304 9.33333333,3.57142857 L9.33333333,6.42857143",
  id: "Shape"
}))));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.9d3d2352.svg";
export { ForwardRef as ReactComponent };